import type { TextFieldProps } from '@mui/material/TextField';
import MuiTextField from '@mui/material/TextField';
import React from 'react';

export type { TextFieldProps } from '@mui/material/TextField';
export type { InputProps } from '@mui/material/Input';

const TextInput = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    return <MuiTextField ref={ref} {...props} />;
  },
);
TextInput.displayName = 'TextInput';
export default TextInput;
